
import {initWebComponent} from "@/helpers/web-component-helper";
import {deleteToken, getUserName, isUserAdmin} from "@/helpers/auth/auth-helper";
import {isMobile} from "@/helpers/mobile-helper";
// import * as bootstrap from "bootstrap";
import {activateUserSessionByID} from "@/helpers/user-session-helper";
import {hideAllInfo, hideLayerInfoForm, initHideButton} from "@/helpers/layer/info/layer-info-helper.js";

export class HeaderLogoutComponent extends HTMLElement {
    constructor(){
        super();

        const user = getUserName()

        let isAdmin = 'd-none'
        if(isUserAdmin() === 'true') {
            isAdmin = ''
        }

        const template = document.createElement('template');

        if(user) {
            let innerHTML = `<div class="btn-group dropdown-menu-right cursor-pointer mt-md-0" style="margin-top:1px">`
            if(isMobile()) {
                innerHTML += `<button style="background-color:` + window.settings.ThemeButtonsColor + `" type="button" class="btn btn-sm btn-secondary dropdown-toggle pl-1 pr-1" data-bs-toggle="dropdown" aria-expanded="true">
                 ` + user.slice(0, 1).toUpperCase() + `
            </button>`
            } else {
                innerHTML += `
            <button class="btn btn-outline-secondary btn-sm borderless popper-header text-transform-none dropdown-toggle popper-header" data-bs-toggle="dropdown" aria-expanded="false">
                  <span class="fa fa-user navbar-icon"></span>
                  <div class="popper-tooltip" role="tooltip" style="position: absolute; inset: 0px auto auto 0px; margin: 0px; transform: translate(-92px, 35px);" data-popper-placement="bottom">
                      Open profiel: ${user}
                      <div class="arrow" data-popper-arrow="" style="position: absolute; left: 0px; transform: translate(113px);"></div>
                  </div>
            </button>`
        }
            innerHTML += `
            <div class="dropdown-menu dropdown-menu-right" style="top: 38px !important;right: -5px;">
                <h5 class="dropdown-header" id="user_profile_full_name"><span class="px-1 text-dark"><i class="fa fa-user mr-1"></i>` + user + `</span></h5>
                <div class="dropdown-divider"></div>
                <button onclick="window.open(window.kaartViewerUrl + '/admin/kaartviewer/account/profile');" class="dropdown-item">
                    <i class="ion ion-ios-person"></i> Mijn profiel
                </button>
                <button id="btnAccountSettings" onclick="window.open(window.kaartViewerUrl + '/admin/kaartviewer/account/settings');" class="dropdown-item">
                    <i class="ion ion-md-settings"></i> Account instellingen
                </button>
                
                <div class="${isAdmin}">
                    <div class="dropdown-divider"></div>
                    <h5 class="dropdown-header">
                        KaartViewer admin
                    </h5>
                    <button onclick="window.open('admin');" class="dropdown-item">
                        <i class="ion ion-md-speedometer"></i> &nbsp;
                        Dashboard
                    </button>
                    <a target="_blank" href="admin/history/text?bookmark=${window.websiteName}&amp;time=1701094615255" class="dropdown-item"><i class="fa fa-history"></i> &nbsp;
                        Historie
                    </a>
                </div>    
                     
                 <div>
                    <div class="dropdown-divider"></div>
                    <button id="userSessionButton" href="admin/history/text?bookmark=${window.websiteName}&amp;time=1701094615255" class="dropdown-item">
                        <i class="fa fa-bookmark"></i> Bookmarks
                    </button>
                </div>
                
                <div class="dropdown-divider"></div>
                
                <div class="dropdown-item"><i class="fa fa-pizza-slice mr-2"></i> <span id="spnVersion">${window.settings.version}</span>
                </div>
                <div class="dropdown-divider"></div>
                <header-logo date-style="max-width: 165px"></header-logo>
                <div class="dropdown-divider"></div>
                <a href="` + window.kaartViewerUrl + '/admin/logout?redirect=../' + window.location.search + `&v=5" id="btnLogOut" class="dropdown-item btn-log-out"><i class="ion ion-ios-log-out text-danger"></i>
                    Uitloggen
                </a>
            </div>
            </div>
        `;

            template.innerHTML = innerHTML
            initWebComponent(this, template)

            this.querySelector('#userSessionButton').addEventListener('click', (e) => {
                const element = document.querySelectorAll('bookmark-session')[0]

                hideLayerInfoForm()

                element.classList.remove('d-none')
                element.parentNode.classList.remove('d-none')

                initHideButton()
            })
            this.querySelector('#btnLogOut').addEventListener('click', (e) => {
                e.preventDefault()
                console.log('logout')
                deleteToken()
                window.location.href = e.target.href
            })
        } else {

            template.innerHTML = `<a href="${window.kaartViewerUrl}/admin/login?redirect=../?${window.location.search}&v=5'" style="margin-top: 5px;" type="button" class="btn btn-sm icon-btn">
                 <i class="fa fa-sign-in-alt">
            </a>`
            initWebComponent(this, template)
        }
    }
}
